
const navLinks = document.querySelectorAll('.nav-item')
const menuToggle = document.getElementById('main-nav')
navLinks.forEach((l) => {
      // only fire on mobile
        l.addEventListener('click', () => { 
            if (menuToggle.classList.contains('show')) {
            let bsCollapse = bootstrap.Collapse.getInstance(menuToggle);
            bsCollapse.toggle() 
            console.log(bsCollapse);
            }
        })
})
